"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetUtilization = void 0;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const __1 = require("..");
const VariableName_1 = require("../VariableName");
exports.assetUtilization = {
    __basic_data_type: true,
    __tsdb_data_type: true,
    __variable_name_data_type: true,
    id: 'assetUtilization',
    variableName: VariableName_1.VariableName.assetUtilization,
    dbTable: __1.TSDBTable.assetUtilization,
    title: 'Utilization',
    icon: free_solid_svg_icons_1.faLayerGroup,
    isSlotted: false,
    order: 1,
    colormap: [
        { value: 0, rgb: [49, 170, 235, 1] },
        { value: 0.6, rgb: [23, 230, 120, 1] },
        { value: 0.8, rgb: [85, 230, 23, 1] },
        { value: 0.9, rgb: [235, 206, 23, 1] },
        { value: 1, rgb: [222, 52, 18, 1] },
    ],
    dataPointConverter: x => x * 100,
    unit: '%',
    decimals: 1,
};
//# sourceMappingURL=asset-utilization.js.map